// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3224":"a751d4a0","5447":"ae7dbdde"}[chunkId] + ".chunk.css";
};